import { collectionOptions } from "@tanstack/db";
import { hashKey, type QueryClient } from "@tanstack/query-core";
import { queryCollectionOptions } from "@tanstack/query-db-collection";
import { apiGet } from "@softmax/observatory-client/client";
import type {
  MyCreditsResponse,
  MyStatusResponse,
} from "@softmax/observatory-client/types";

type UsageScope = {
  readonly viewerId: string;
  readonly elevatedPrivileges: boolean;
};

export function myUsageStatusCollection(scope: UsageScope) {
  const queryKey = ["usage", "me", "status", scope] as const;
  return collectionOptions(hashKey(queryKey), (client) =>
    queryCollectionOptions({
      queryClient: client.requireDependency<QueryClient>("queryClient"),
      queryKey,
      queryFn: async ({ signal }) => [
        {
          id: "status" as const,
          ...(await apiGet<MyStatusResponse>("/usage/me/status", {
            signal,
            elevatedPrivileges: scope.elevatedPrivileges,
          })),
        },
      ],
      getKey: (status) => status.id,
      staleTime: 30_000,
    }),
  );
}

export function myCreditsCollection(scope: UsageScope) {
  const queryKey = ["usage", "me", "credits", scope] as const;
  return collectionOptions(hashKey(queryKey), (client) =>
    queryCollectionOptions({
      queryClient: client.requireDependency<QueryClient>("queryClient"),
      queryKey,
      queryFn: async ({ signal }) => [
        {
          id: "credits" as const,
          ...(await apiGet<MyCreditsResponse>("/usage/me/credits", {
            signal,
            elevatedPrivileges: scope.elevatedPrivileges,
          })),
        },
      ],
      getKey: (credits) => credits.id,
      staleTime: 30_000,
    }),
  );
}
